import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserPermissions } from '../../hooks/useUserPermissions';
import LoadingSpinner from '../ui/LoadingSpinner';

interface PermissionProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission: keyof ReturnType<typeof useUserPermissions>;
  fallbackPath?: string;
}

const PermissionProtectedRoute: React.FC<PermissionProtectedRouteProps> = ({ 
  children, 
  requiredPermission, 
  fallbackPath = '/dashboard' 
}) => {
  const permissions = useUserPermissions();
  const hasPermission = permissions[requiredPermission];

  if (hasPermission === undefined) {
    // Ainda carregando permissões
    return <LoadingSpinner />;
  }

  if (!hasPermission) {
    // Usuário não tem permissão, redirecionar
    return <Navigate to={fallbackPath} replace />;
  }

  // Usuário tem permissão, renderizar conteúdo
  return <>{children}</>;
};

export default PermissionProtectedRoute;
